import React from "react";
import { TagsRow, Code, DimensionTag, SubDimensionTag, LevelTag } from "./styles";

/**
 * Etiqueta del nivel de dificultad a partir de los codigos que devuelve el API,
 * ya ordenados por posicion: ['I','II'] -> "VFCS I - II", ['V'] -> "VFCS V".
 *
 * Se pinta como rango porque los niveles de una actividad son siempre
 * consecutivos. Si algun dia dejan de serlo, ['I','III'] se veria como
 * "VFCS I - III" e incluiria un nivel que no toca, asi que se avisa por consola
 * en vez de mentir en silencio.
 */
export const formatLevels = (scale, levels = []) => {
  if (!levels.length) return "";
  const label = levels.length === 1 ? levels[0] : `${levels[0]} - ${levels[levels.length - 1]}`;
  return scale ? `${scale} ${label}` : label;
};

/** Fila de codigo + dimension + sub-dimension + nivel, comun a las dos vistas. */
const ActivityTaxonomy = ({ activity }) => {
  const levels = formatLevels(activity.difficulty_scale, activity.difficulty_levels);

  return (
    <TagsRow>
      {activity.code && <Code>{activity.code}</Code>}
      {activity.dimension && <DimensionTag>{activity.dimension}</DimensionTag>}
      {activity.sub_dimension && <SubDimensionTag>{activity.sub_dimension}</SubDimensionTag>}
      {levels && <LevelTag>{levels}</LevelTag>}
    </TagsRow>
  );
};

export default ActivityTaxonomy;
